import { render } from "./invoice-batch-created-notification.vue?vue&type=template&id=00b7d210&ts=true"
import script from "./invoice-batch-created-notification.ts?vue&type=script&lang=ts&external"
export * from "./invoice-batch-created-notification.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__